import { flex, stack } from "@styled-system/patterns";

export const variablesWrapperClass = stack({
	gap: "2",
	marginBottom: "16",
	backgroundColor: "shade.5",
	padding: "16",
	borderRadius: "8",
});

export const variablesListClass = flex({
	gap: "4",
	marginTop: "8",
	flexWrap: "wrap",
});
